import { call, put, takeEvery } from 'typed-redux-saga';

import DashboardGateway from '~apis/dashboard';
import combinedActions from '~redux/combinedActions';

import { store } from '~redux/store';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';

export default function* watchOpenDashboardMarket(api: DashboardGateway): SagaWatcherReturnType {
    yield takeEvery('dashboard/dashboardOpenDashboardMarketAttempt', handleOpenDashboardMarket, api);
}

function* handleOpenDashboardMarket(api: DashboardGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.openDashboardMarket], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.dashboardOpenDashboardMarketFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.dashboardIsMarketStatusOpenConfimationModalOpen(false));
        yield put(combinedActions.dashboardGetDashboardMarketStatusAttempt());
        yield put(combinedActions.dashboardOpenDashboardMarketSuccess(response.data));
    }
}
